import { GameState, Unlock } from '@/types/career-sim';

export const unlocks: Unlock[] = [
  { 
    actionId: 'perform-live', 
    requirements: { week: 4, fans: 50 },
    unlocked: false
  },
  { 
    actionId: 'marketing-campaign', 
    requirements: { week: 6, fans: 200 },
    unlocked: false
  },
  { 
    actionId: 'collaboration', 
    requirements: { week: 8, fans: 500, reputation: 20 },
    unlocked: false
  },
  { 
    actionId: 'release-album', 
    requirements: { week: 10, releases: 3 },
    unlocked: false
  },
  { 
    actionId: 'start-label', 
    requirements: { week: 14, funds: 5000, fans: 1000 },
    unlocked: false
  },
  { 
    actionId: 'tour', 
    requirements: { week: 16, fans: 5000, reputation: 50 },
    unlocked: false
  },
];

export const checkUnlocks = (gameState: GameState): string[] => {
  const newlyUnlocked: string[] = [];

  unlocks.forEach(unlock => {
    if (gameState.unlockedActions.includes(unlock.actionId)) {
      return; // Already unlocked
    }

    const meetsRequirements = 
      (!unlock.requirements.week || gameState.currentWeek >= unlock.requirements.week) &&
      (!unlock.requirements.fans || gameState.career.fanbase >= unlock.requirements.fans) &&
      (!unlock.requirements.funds || gameState.career.funds >= unlock.requirements.funds) &&
      (!unlock.requirements.reputation || gameState.career.reputation >= unlock.requirements.reputation) &&
      (!unlock.requirements.releases || gameState.career.totalReleases >= unlock.requirements.releases);

    if (meetsRequirements) {
      newlyUnlocked.push(unlock.actionId);
    }
  });

  return newlyUnlocked;
};

export const getUnlockDetails = (actionId: string) => {
  return unlocks.find(u => u.actionId === actionId);
};

export const isActionLocked = (actionId: string, gameState: GameState): boolean => {
  return !gameState.unlockedActions.includes(actionId) && unlocks.some(u => u.actionId === actionId);
};

export const getLockedReason = (actionId: string, gameState: GameState): string => {
  const unlock = unlocks.find(u => u.actionId === actionId);
  if (!unlock) return '';

  const reasons: string[] = [];
  
  if (unlock.requirements.week && gameState.currentWeek < unlock.requirements.week) {
    reasons.push(`Week ${unlock.requirements.week}`);
  }
  if (unlock.requirements.fans && gameState.career.fanbase < unlock.requirements.fans) {
    reasons.push(`${unlock.requirements.fans} fans`);
  }
  if (unlock.requirements.funds && gameState.career.funds < unlock.requirements.funds) {
    reasons.push(`$${unlock.requirements.funds}`);
  }
  if (unlock.requirements.reputation && gameState.career.reputation < unlock.requirements.reputation) {
    reasons.push(`${unlock.requirements.reputation} reputation`);
  }
  if (unlock.requirements.releases && gameState.career.totalReleases < unlock.requirements.releases) {
    reasons.push(`${unlock.requirements.releases} releases`);
  }

  return reasons.length > 0 ? `Requires: ${reasons.join(', ')}` : '';
};
